import Billing from './BillingPolicy'
import BusinessObject from './BusinessObjectPolicy'
import Fonenumber from './FonenumberPolicy'
import Analytics from './AnalyticsPolicy'
import SubAccount from './SubAccountPolicy'
import User from './UserPolicy'
import Account from './AccountPolicy'
import Profile from './ProfilePolicy'
import WhiteLabel from './WhiteLabelPolicy'
import MessagingBrand from './MessagingBrandPolicy'

export default {
  Billing,
  BusinessObject,
  Fonenumber,
  Analytics,
  SubAccount,
  User,
  Account,
  Profile,
  WhiteLabel,
  MessagingBrand
}



// WEBPACK FOOTER //
// ./src/policy/index.js